import { BaseGcpResource } from '@apis/Resources/model';
import { PropertyGridItem } from '@root/Components/PropertyGrid/Models';
import { ReactNode } from 'react';

type ResourceTypeFieldConfig = {
    [resourceType: string]: {
        [fieldPath: string]: {
            label?: string;
            valueRenderer?: (item: PropertyGridItem) => ReactNode;
            format?: (item: PropertyGridItem) => string | undefined;
            value?: (resource: BaseGcpResource) => unknown;
            hidden?: boolean;
        };
    };
};

export function useGcpResourceFieldConfig() {
    const gcpCommonFields: ResourceTypeFieldConfig[''] = {
        Account: { hidden: true },
        AccountID: { hidden: true },
        GcpId: {},
        kind: {},
        location: {},
        ParentCreateDate: { hidden: true },
        ResourceGroup: {},
        SubscriptionId: {},
        Subscription: {},
        'sku.name': {},
        'sku.tier': {},
        Type: {
            hidden: true,
        },
        InheritedTags: { hidden: true },
        Etag: { hidden: true },
        ProjectId: {},
        ProjectName: {},
    };
    return { gcpCommonFields };
}
